const mEditionAcademyUsersProfile = {
  mEditionAcademyUsersProfile: {
    alerts: {
      updateAcademiaActorEstado: {
        activationSuccess: 'El rol de usuario fue activado exitosamente.',
        deactivationSuccess: 'El rol de usuario fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    messages: {
      activeSince: 'Activo desde',
      noContact: 'sin información de contacto',
      mobile: 'Móvil',
      noLegal: 'sin información legal',
      noLocation: 'sin información de ubicación',
      noNumber: 'sin número',
      phone: 'Teléfono'
    },

    title: 'ROLES DE USUARIO'
  }
}
export default mEditionAcademyUsersProfile
